/**
 * Salento real-estate glossary — alphabetical long-tail content. Each
 * term is a self-contained definition (40-80 words) optimised for
 * "definition X" search queries.
 *
 * Schema.org DefinedTermSet is emitted in the page for rich understanding
 * by Google. Backwards-compatible default export `GLOSSARY` preserved for
 * existing call sites; use `getGlossary(lang)` for new code.
 */

const GLOSSARY_IT = [
  {
    term: "Abuso edilizio",
    def: "Costruzione, ampliamento o modifica realizzata senza permesso di costruire (o in difformità dal progetto approvato). In Italia è reato e blocca il rogito. Si può sanare con accertamento di conformità o, in casi specifici, con condono — quando previsto da legge speciale (ultimi nel 2003).",
  },
  {
    term: "Agibilità",
    def: "Certificato che attesta che l'immobile è abitabile in sicurezza (statica, impianti, igiene). Obbligatorio dal 1934 per residenziale, dal 2016 sostituito dalla SCIA di agibilità. Senza agibilità la casa è inutilizzabile come residenza e non finanziabile da banche.",
  },
  {
    term: "APE (Attestato di Prestazione Energetica)",
    def: "Certificato che classifica l'immobile da A+ (efficientissimo) a G (energivoro). Obbligatorio in ogni atto di vendita o locazione. Validità 10 anni. Classe G implica spese di riscaldamento/raffreddamento elevate, classe A+ riduce le bollette del 70-80%.",
  },
  {
    term: "Fascia costiera 300 metri (vincolo Galasso)",
    def: "Area di 300 metri dalla battigia tutelata dalla Legge Galasso (L. 431/85). All'interno è vietata ogni nuova costruzione. Sono ammesse solo manutenzione ordinaria e straordinaria su immobili preesistenti, senza modifica della sagoma o aumento di volume.",
  },
  {
    term: "IMU (Imposta Municipale Unica)",
    def: "Imposta annuale sui fabbricati diversi dalla prima casa di residenza. Si calcola: rendita catastale × 1,05 × moltiplicatore (160 per A/2, 140 per A/3, 65 per terreni) × aliquota comunale (8,6‰-10,6‰). Per seconde case in Salento conta su 600-2.500 €/anno.",
  },
  {
    term: "Lamia",
    def: "Costruzione rurale salentina a pianta rettangolare e copertura piana o a botte, costruita in pietra a secco. Differente dal trullo (pianta circolare e tetto conico), era usata come riparo per attrezzi agricoli e occasionalmente come abitazione temporanea per i contadini.",
  },
  {
    term: "OMI (Osservatorio del Mercato Immobiliare)",
    def: "Banca dati gratuita dell'Agenzia delle Entrate. Pubblica due volte l'anno le quotazioni medie €/m² per zona omogenea, tipologia (residenziale, commerciale, terreno) e stato di conservazione. Riferimento ufficiale per banche, periti e Fisco. Consultabile su agenziaentrate.gov.it.",
  },
  {
    term: "Pajara",
    def: "Costruzione rurale del basso Salento, simile al trullo ma più piccola e con tecnica costruttiva diversa (pietre a secco con falsa cupola). Era riparo temporaneo per pastori e contadini. Tutelata come bene paesaggistico ma molto fragile: la ristrutturazione richiede maestri specializzati.",
  },
  {
    term: "PPTR (Piano Paesaggistico Territoriale Regionale)",
    def: "Strumento normativo della Regione Puglia (approvato 2015) che disciplina la tutela del paesaggio. Suddivide il territorio in aree con diversi livelli di vincolo. Prima di acquistare in zona rurale o costiera, verificare la collocazione dell'immobile nel PPTR.",
  },
  {
    term: "PUG (Piano Urbanistico Generale)",
    def: "Strumento urbanistico comunale che disciplina l'uso del suolo. Determina cosa si può costruire, dove e come. Sostituisce il vecchio PRG. Va sempre verificato prima dell'acquisto: una particella catastale può essere edificabile sul PUG vecchio e agricola sul nuovo.",
  },
  {
    term: "Rendita catastale",
    def: "Valore fiscale dell'immobile attribuito dall'Agenzia del Territorio. Base per calcolare IMU, TARI, imposta di registro su seconda casa. NON è il valore di mercato (è tipicamente 5-15 volte inferiore). Si trova nella visura catastale.",
  },
  {
    term: "Sanatoria edilizia",
    def: "Procedura per regolarizzare un abuso edilizio. Si distingue in: condono (eccezionale, ultimo 2003) e accertamento di conformità (ordinario, art. 36 DPR 380/01) per opere conformi alle norme vigenti sia all'epoca dell'abuso sia oggi. Costi: 5.000-30.000 € per immobili residenziali tipici.",
  },
  {
    term: "SCIA (Segnalazione Certificata Inizio Attività)",
    def: "Comunicazione al Comune per iniziare lavori di manutenzione straordinaria, ristrutturazione leggera o cambio di destinazione d'uso. Sostituisce la vecchia DIA. Si presenta tramite tecnico abilitato, senza attesa di risposta. Differente dal Permesso di Costruire (richiesto per nuove costruzioni).",
  },
  {
    term: "Sopraelevazione",
    def: "Aumento di altezza di un edificio mediante aggiunta di uno o più piani. In Puglia è vincolata: nelle zone costiere (300m) è quasi sempre vietata; nei centri storici richiede autorizzazione paesaggistica; in zona agricola è regolata dal PUG comunale.",
  },
  {
    term: "Trullo",
    def: "Costruzione tradizionale della Valle d'Itria (Alberobello, Cisternino, Locorotondo, Martina Franca, Ostuni) in pietra a secco a pianta circolare, con copertura conica a falsa cupola. Patrimonio UNESCO. Vincolato come bene storico: il cono originale non può essere alterato.",
  },
  {
    term: "Ulivi monumentali",
    def: "Ulivi di età stimata superiore ai 100 anni, censiti e tutelati dalla Regione Puglia (L.R. 14/2007). Vietato espiantarli, salvo deroga regionale. Aumentano sensibilmente il valore del terreno (5.000-20.000 € per pianta) ma vincolano la destinazione d'uso.",
  },
  {
    term: "Vincolo paesaggistico",
    def: "Tutela imposta dal D.lgs 42/2004 (Codice dei Beni Culturali e del Paesaggio). Richiede autorizzazione paesaggistica per qualsiasi modifica esterna dell'immobile (infissi, intonaci, ampliamenti, fotovoltaico). In Salento copre fasce costiere, centri storici, zone SIC/ZPS, ulivi monumentali.",
  },
  {
    term: "Vincolo Soprintendenza",
    def: "Tutela di beni di interesse storico-architettonico applicata dalla Soprintendenza Archeologia, Belle Arti e Paesaggio. Più restrittiva del vincolo paesaggistico: ogni intervento (anche interno strutturale, manutenzione facciata) richiede nulla osta. Comune nei centri storici salentini.",
  },
  {
    term: "Xylella fastidiosa",
    def: 'Batterio che dal 2013 ha devastato gli uliveti del Salento. Causa il "Complesso del Disseccamento Rapido dell\'Olivo" (CoDiRO). Prima di acquistare un terreno con ulivi: richiedere certificazione fitosanitaria recente (max 6 mesi) e verificare l\'inclusione in zona infetta o cuscinetto.',
  },
  {
    term: "ZTL (Zona a Traffico Limitato)",
    def: "Area urbana con accesso veicolare ristretto a residenti, mezzi di soccorso, fornitori autorizzati. Diffusa nei centri storici di Lecce, Ostuni, Otranto. Incide sulla comodità abitativa e sul valore degli appartamenti turistici (parcheggio difficile = penalizzazione lieve di prezzo).",
  },
];

const GLOSSARY_EN = [
  {
    term: "Abuso edilizio (unauthorised construction)",
    def: "Construction, extension or modification carried out without a building permit (or in non-compliance with the approved project). In Italy it's a criminal offence and blocks the property deed. It can be regularised via 'accertamento di conformità' or, in specific cases, an amnesty (last one in 2003).",
  },
  {
    term: "Agibilità (habitability certificate)",
    def: "Certificate stating the property is safely habitable (structural, systems, hygiene). Mandatory since 1934 for residential, replaced in 2016 by the 'SCIA di agibilità'. Without agibilità the property cannot be used as a residence and cannot be financed by banks.",
  },
  {
    term: "APE (Energy Performance Certificate)",
    def: "Certificate ranking the property from A+ (most efficient) to G (energy-intensive). Mandatory in every sale or rental deed. 10-year validity. Class G implies high heating/cooling costs, class A+ reduces bills by 70-80%.",
  },
  {
    term: "300m coastal strip (Galasso constraint)",
    def: "Area within 300 metres from the shoreline protected by Italian Law 431/85 (Legge Galasso). New constructions are forbidden. Only routine and extraordinary maintenance on pre-existing buildings is allowed — no shape change, no volume increase.",
  },
  {
    term: "IMU (Single Municipal Tax)",
    def: "Annual tax on properties other than the primary residence. Calculated as: cadastral income × 1.05 × multiplier (160 for A/2, 140 for A/3, 65 for land) × municipal rate (8.6‰-10.6‰). Expect €600-2,500/year for a typical second home in Salento.",
  },
  {
    term: "Lamia",
    def: "Salento rural building with a rectangular floor plan and a flat or barrel-vaulted roof, built in dry stone. Unlike the trullo (circular plan and conical roof), it was used as shelter for farm tools and occasionally as a temporary dwelling for farmers.",
  },
  {
    term: "OMI (Real Estate Market Observatory)",
    def: "Free database run by the Italian Revenue Agency. It publishes average €/m² values twice a year by homogeneous zone, property type (residential, commercial, land) and condition. Official reference for banks, surveyors and tax authorities. Available on agenziaentrate.gov.it.",
  },
  {
    term: "Pajara",
    def: "Rural construction of lower Salento, similar to the trullo but smaller and built with a different technique (dry-stone walls with false-dome roof). Used as temporary shelter by shepherds and farmers. Protected as landscape heritage but fragile — restoration requires specialised craftsmen.",
  },
  {
    term: "PPTR (Regional Landscape Territorial Plan)",
    def: "Regulatory tool of the Apulia Region (approved in 2015) governing landscape protection. Divides the territory into areas with different constraint levels. Before buying in rural or coastal areas, always verify the property's classification in the PPTR.",
  },
  {
    term: "PUG (General Urban Plan)",
    def: "Municipal planning tool governing land use. Determines what can be built, where and how. Replaces the old PRG. Always check before buying: a cadastral parcel can be classified as buildable in the old PUG and as agricultural in the new one.",
  },
  {
    term: "Rendita catastale (cadastral income)",
    def: "Fiscal value of the property assigned by the Land Registry. Basis for IMU, TARI and registration tax on second homes. NOT the market value (typically 5-15 times lower). Found in the cadastral certificate ('visura catastale').",
  },
  {
    term: "Sanatoria edilizia (building amnesty)",
    def: "Procedure to regularise unauthorised construction. Two flavours: 'condono' (exceptional, last in 2003) and 'accertamento di conformità' (ordinary, art. 36 DPR 380/01) for works compliant with rules both at the time of the abuse and today. Costs: €5,000-30,000 for typical residential properties.",
  },
  {
    term: "SCIA (Certified Notice of Activity Start)",
    def: "Notification to the Municipality to start extraordinary maintenance, light renovation or change of use. Replaces the old DIA. Filed via a qualified technician, no waiting period. Different from the Building Permit (required for new constructions).",
  },
  {
    term: "Sopraelevazione (vertical extension)",
    def: "Increasing the height of a building by adding one or more floors. In Apulia it's constrained: almost always forbidden in coastal areas (300m), requires landscape authorisation in historic centres, regulated by the municipal PUG in agricultural areas.",
  },
  {
    term: "Trullo",
    def: "Traditional construction of the Valle d'Itria (Alberobello, Cisternino, Locorotondo, Martina Franca, Ostuni) in dry stone, with a circular floor plan and a false-dome conical roof. UNESCO Heritage. Protected as historic asset — the original cone cannot be altered.",
  },
  {
    term: "Monumental olive trees",
    def: "Olive trees over 100 years old, registered and protected by Apulia Region (L.R. 14/2007). Removal is forbidden except by regional derogation. They significantly increase land value (€5,000-20,000 per plant) but constrain the intended use.",
  },
  {
    term: "Vincolo paesaggistico (landscape constraint)",
    def: "Protection imposed by D.lgs 42/2004 (Code of Cultural Heritage and Landscape). Requires landscape authorisation for any external change (windows, plaster, extensions, photovoltaic). In Salento it covers coastal strips, historic centres, SIC/ZPS areas, monumental olive trees.",
  },
  {
    term: "Soprintendenza constraint",
    def: "Protection of historic-architectural heritage applied by the Soprintendenza for Archaeology, Fine Arts and Landscape. More restrictive than the landscape constraint: every intervention (including internal structural work, façade maintenance) requires clearance. Common in Salento's historic centres.",
  },
  {
    term: "Xylella fastidiosa",
    def: "Bacterium that has devastated Salento olive groves since 2013. Causes the 'Olive Quick Decline Syndrome' (CoDiRO). Before buying land with olive trees: request a recent phytosanitary certificate (max 6 months) and check inclusion in the infected or buffer zone.",
  },
  {
    term: "ZTL (Limited Traffic Zone)",
    def: "Urban area with vehicle access restricted to residents, emergency vehicles and authorised suppliers. Common in the historic centres of Lecce, Ostuni, Otranto. Affects residential convenience and the value of tourist apartments (difficult parking = mild price penalty).",
  },
];

export const GLOSSARY_BY_LANG = { it: GLOSSARY_IT, en: GLOSSARY_EN };

/** Return the glossary for the requested language, falling back to IT. */
export const getGlossary = (lang = "it") =>
  GLOSSARY_BY_LANG[lang] || GLOSSARY_BY_LANG.it;

// Back-compat default export — existing call sites expecting plain IT.
export const GLOSSARY = GLOSSARY_IT;
